import React, { useContext, useEffect, useState } from 'react'

// import { useCompany } from '../../hooks/CompanyConfiguration/useCompany'
import { formatDate, ROUTES } from '../../shared/constants'
import { useHistory } from 'react-router'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useDownload } from '../../hooks/Download/useDownload'
import { useCompany } from '../../hooks/SuperAdmin/useCompany'
import { SuperAdminContext } from '../../context api/SuperAdmin/SuperAdminContext'

export default function Company() {
  const { getAllCompany, deleteManyCompany, loading, paginate, updateCompany } = useCompany()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { companies } = useContext(SuperAdminContext)
  //console.log('companies : ', companies)
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterCompany = companies
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllCompany({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_COMPANIES')
  }, [])

  const handleChange = (event, value) => {
    setPage(value)
  }

  const tempHeaders = [{ label: 'companyCode' }, { label: 'name' }]

  const handleSwitchChange = (item) => updateCompany({ ...item, active: !item.active, companyId: item._id })

  let tableBody = []

  if (!loading && filterCompany.length > 0) {
    tableBody = filterCompany.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { value: item.companyAdminCode },
        { value: item.name },
        { value: item.phoneNumber },
        { value: item.email },
        { value: formatDate(item.createdAt) },
        { type: 'STATUS', ...item },
        { image: item.logo, type: "IMAGE" },
        { type: 'INFO', onClick: () => history.push(`/view-company/${item._id}`) },
      ]
    })
  }

  const layoutProps = {
    heading: 'Manage Companies',
    url: ROUTES.ADD_COMPANY,
    editUrl: `/edit-company/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaderData: [],
    filename: 'companies',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Company Code', 'Name', 'phone number', 'email', 'Created Date', 'Status', "logo", 'Info']}
      loading={loading}
      tableBody={tableBody}
      handleSwitchChange={handleSwitchChange}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => deleteManyCompany({ companyId: val }, setSelected)}
    />
  )
}
